import { render } from "./OSearch.vue?vue&type=template&id=3c1134b1&scoped=true"
import script from "./OSearch.vue?vue&type=script&lang=js"
export * from "./OSearch.vue?vue&type=script&lang=js"

import "./OSearch.vue?vue&type=style&index=0&id=3c1134b1&lang=css"
import "./OSearch.vue?vue&type=style&index=1&id=3c1134b1&scoped=true&lang=css"

import exportComponent from "/home/forge/mymembership.id/releases/82161804/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c1134b1"]])

export default __exports__